import React, { useEffect } from 'react';
import { useRMDispatch } from 'redux/hooks';
import {
  useHasBufferType,
  useIngredientLoadingState,
} from 'redux/hooks/IngredientDetail';
import { getIngredientData } from 'redux/reducers/ingredientDetailReducer';
import Aliases from './Aliases';
import CASNumbers from './CASNumbers';
import IngredientHeader from './Header';
import Info from './Info';
import { MixingCurve } from './MixingCurve';
import StockComments from './StockComments';
import Stocks from './Stocks';
import { TitrationCurve } from './TitrationCurve';
import Types from './Types';
import { LoadingModal } from 'components/modal';

const Layout = ({ ingredientId, closeModal = null }) => {
  const hasBufferType = useHasBufferType();
  const isLoading = useIngredientLoadingState();
  const dispatch = useRMDispatch();
  useEffect(() => {
    dispatch(getIngredientData(ingredientId));
  }, []);

  return (
    <div id="layout-ingredients-container" className="flex w-full h-full gap-2 flex-col">
      <div id="layout-ingredients-header" className="basis-1/12 max-h-[10%]">
        <IngredientHeader closeModal={closeModal} />
      </div>
      <div
        id="layout-ingredients-content-wrapper"
        className="basis-11/12 flex gap-2 p-2 max-h-[90.7%] min-h-[69vh]"
      >
        <div
          id="layout-ingredients-content-leftside"
          className="basis-3/12 flex flex-col gap-[1%]"
        >
          <div
            id="layout-ingredients-content-info"
            className="basis-[30%] flex max-h-[30%]"
          >
            {' '}
            <Info />{' '}
          </div>
          <div
            id="layout-ingredients-content-types"
            className="basis-[34%] flex max-h-[35%]"
          >
            <Types />
          </div>
          <div
            id="layout-ingredients-content-row"
            className="basis-[34%] flex flex-row gap-2 max-h-[35%]"
          >
            <div id="layout-ingredients-content-aliases" className="basis-3/5 flex">
              <Aliases />
            </div>
            <div id="layout-ingredients-content-casnumbers" className="basis-2/5 flex">
              <CASNumbers />
            </div>
          </div>
        </div>
        <div
          id="layout-ingredients-content-rightside"
          className="basis-3/4 flex flex-col gap-2"
        >
          <div
            id="layout-ingredients-content-row2"
            className={`${hasBufferType ? 'flex' : 'hidden'} max-h-[40%] flex-row gap-2`}
          >
            <div id="layout-ingredients-content-titrationcurve" className="flex">
              <TitrationCurve />
            </div>
            <div id="layout-ingredients-content-mixingcurve" className="flex">
              {' '}
              <MixingCurve />{' '}
            </div>
          </div>
          <div
            id="layout-ingredients-content-stocks"
            className={`${hasBufferType ? 'h-[30vh]' : 'h-[52vh]'}  flex`}
          >
            <Stocks />
          </div>
          <div id="layout-ingredients-content-stockcomments" className="flex">
            <StockComments />
          </div>
        </div>
      </div>
      <LoadingModal showModal={isLoading} text="Loading" />
    </div>
  );
};

export default Layout;
